module.exports = __webpack_public_path__ + "img/package-3.284bebb5.png";